export default "__VITE_ASSET__877f8$Fd__"